/**
 * admin-frontend axios client — BFF(/api) 호출.
 *
 * 인증: admin_at httpOnly 쿠키 자동(withCredentials). 401 → 세션 만료 → 로그인 화면 redirect.
 * baseURL='/api' (BFF) — chat-server frontend 의 '/api/v1' 과 다름(BFF 가 v1 prefix 부착).
 */
import axios, { AxiosError, type AxiosInstance } from 'axios';
import { useAdminAuthStore } from '../store/adminAuthStore';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api';

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30_000,
});

// 401 → 세션 만료 처리. admin 은 refresh 없음(독립 로그인) → 즉시 로그아웃 상태.
apiClient.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // /auth/me 자체 401 은 로그인 판정용이라 store 만 클리어(무한 루프 방지).
      useAdminAuthStore.getState().clearSession();
    }
    return Promise.reject(error);
  },
);
